import { call, all, put, takeLatest } from 'redux-saga/effects';

import notification from '../../../services/notification';
import history from '../../../services/history';
import loadtypeService from './load-type-service';
import * as loadtypeActions from './load-type-actions';
import { GET_ALL_REQUEST, GET_BY_ID_REQUEST, SAVE_REQUEST, EDIT_ITEM, DELETE_ITEM } from './load-type-constants';
import { ISA_ERROR } from '../../../constants';
import { formatMessage } from '~/i18n/translate';

const INITIAL_VALUES = {
  code: '',
  name: '',
  deliveryType: 'CIF'
};

export function* getAll() {
  try {
    yield put(loadtypeActions.setLoadingData(true));

    const { data } = yield call(loadtypeService.getAll);
    if (data) {
      yield put(loadtypeActions.getAllSuccess([...data]));
    }

    yield put(loadtypeActions.setLoadingData(false));
  } catch (error) {
    yield put(loadtypeActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* getById({ id }: any) {
  try {
    yield put(loadtypeActions.setLoadingData(true));

    if (!id) {
      yield put(
        loadtypeActions.getByIdSuccess({
          data: INITIAL_VALUES
        })
      );
    } else {
      const { data } = yield call(loadtypeService.getLoadType, id);
      if (data) {
        yield put(
          loadtypeActions.getByIdSuccess({
            data
          })
        );
      }
    }
    yield put(loadtypeActions.setLoadingData(false));
  } catch (error) {
    yield put(loadtypeActions.setLoadingData(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* save(data: any) {
  try {
    const { id, payload } = data;
    yield put(loadtypeActions.setLoadingSend(true));

    const team = {
      ...payload,
      usersIDs: payload?.users?.map((s: any) => s._id)
    };

    if (id) {
      yield call(loadtypeService.editLoadType, { _id: id, ...team });
    } else {
      yield call(loadtypeService.createLoadType, team);
    }
    yield call(history.push, `/register/load-type/`, {
      date: new Date().getTime()
    });
    yield put(loadtypeActions.setLoadingSend(false));
    yield call(
      notification.success,
      id ? formatMessage('loadTypeFormUpdatedMessage') : formatMessage('loadTypeFormCreatedMessage')
    );
  } catch (error) {
    yield put(loadtypeActions.setLoadingSend(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* deleteItem({ id }: any) {
  try {
    const { isConfirmed } = yield call(
      notification.confirm,
      formatMessage('commonLabelExclude'),
      formatMessage('commonLabelExcludeItem')
    );
    if (isConfirmed) {
      yield put(loadtypeActions.setLoadingSend(true));
      yield call(loadtypeService.deleteLoadType, id);
      yield put(loadtypeActions.setLoadingSend(false));

      yield put(loadtypeActions.getAllRequest());
      yield call(notification.success, formatMessage('loadTypeFormExcludeMessage'));
    }
  } catch (error) {
    yield put(loadtypeActions.setLoadingSend(false));
    yield put({ type: ISA_ERROR, error });
  }
}

export function* editItem({ id }: any) {
  yield call(history.push, `/register/load-type/edit/${id}`);
}

export default all([
  takeLatest(GET_ALL_REQUEST, getAll),
  takeLatest(GET_BY_ID_REQUEST, getById),
  takeLatest(SAVE_REQUEST, save),
  takeLatest(DELETE_ITEM, deleteItem),
  takeLatest(EDIT_ITEM, editItem)
]);
